import React, { useEffect, useState } from "react"
import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { Button } from "@Components/CustomButton/Button"
import SvgMascotte from "@Components/CustomIcon/SvgMascotte"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { ReminderCardItem } from "@Components/FollowUp/Reminder/ReminderCardItem"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import { reminderPayloadAtom, remindersListAtom, reminderTypesAtom } from "@Recoil/Atom/reminderAtom"
import { userAtom } from "@Recoil/Atom/userAtom"
import { ReminderService } from "@Services/Reminder.Service"
import { ActivityIndicator } from "react-native-paper"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import { defaultReminder } from "./ReminderForm"

export const ReminderHome = ({ navigation }) => {
    const [types, setTypes] = useRecoilState(reminderTypesAtom)
    const user = useRecoilValue(userAtom)
    const setReminder = useSetRecoilState(reminderPayloadAtom)
    const [reminders, setReminders] = useRecoilState(remindersListAtom)
    const [fetchingReminders, setFetchingReminders] = useState(true)
    const [fetchingReminderTypes, setFetchingReminderTypes] = useState(true)

    const fetchReminderTypes = () => {
        setFetchingReminderTypes(true)
        ReminderService.getTypes()
            .then((response) => {
                const data = response.data?.data

                if (data) {
                    let parsed = data.map((d) => {
                        return {
                            label: d?.name,
                            value: d?.id
                        }
                    })

                    setTypes(parsed)
                }
                setFetchingReminderTypes(false)
            })
            .catch((err) => {
                console.log({ err })
                setFetchingReminderTypes(false)
            })
    }

    const fetchReminders = () => {
        setFetchingReminders(true)
        ReminderService.getList(+user?.id)
            .then((response) => {
                const data = response?.data?.data
                if (data) {
                    setReminders([...data])
                }
                setFetchingReminders(false)
            })
            .catch((e) => {
                console.log({ err: e })
                setFetchingReminders(false)
            })
    }

    useEffect(() => {
        fetchReminderTypes()
        fetchReminders()
    }, [user?.id])

    useEffect(() => {
        const unsubscribe = navigation.addListener("focus", () => {
            fetchReminders()
            setReminder(defaultReminder)
        })

        // Return the function to unsubscribe from the event so it gets removed on unmount
        return unsubscribe
    }, [navigation])

    const editReminder = (item) => navigation.navigate("ReminderForm", { data: item })

    return (
        <ContainerStackScreen>
            <CustomScrollview showsVerticalScrollIndicator={false} contentContainerStyle={{ paddingBottom: 100 }}>
                <BreeSerifText color={baseColors.green.primary} fontSize={24}>
                    Mes rappels
                </BreeSerifText>

                <Spacer height={15} />

                <OpenSansText fontSize={16}>
                    Créez des rappels : prise de médicaments, rendez-vous, activité sportive, etc.{" "}
                </OpenSansText>

                <Spacer height={20} />

                {fetchingReminders ? (
                    <ActivityIndicator color={baseColors.orange.primary} size={"large"} />
                ) : (
                    reminders?.map((item, i) => (
                        <ReminderCardItem
                            backgroundColor={i % 2 === 0 ? baseColors.green.primary : baseColors.orange.primary}
                            onPress={() => editReminder(item)}
                            key={i}
                            {...item}
                        />
                    ))
                )}

                {!fetchingReminders && reminders?.length === 0 && (
                    <>
                        <SvgMascotte style={{ marginVertical: 20, alignSelf: "center" }} width={278} height={278} />
                        <OpenSansText fontSize={16} textAlign={"center"}>
                            Cette partie est vide... Créez vos propres rappels pour ne rien oublier !
                        </OpenSansText>
                    </>
                )}

                <Spacer height={15} />

                <Button
                    disabled={fetchingReminders || fetchingReminderTypes}
                    onPress={() => navigation.navigate("ReminderForm")}
                    text="Créer"
                    width="100%"
                    backgroundColor={baseColors.green.primary}
                    labelColor={"white"}
                />
            </CustomScrollview>
        </ContainerStackScreen>
    )
}
